/**
 * The supervisor tab's API — `/api/v1/supervisor` (tasks/supervisor-view.md).
 *
 * One read for the whole tab, and one write: recording that a human chased somebody. Both go through
 * the shared `secureApi` instance, which attaches the token and handles 401/403 in one place —
 * `taskApi.js` predates that and builds its own headers; it is not the pattern to copy.
 *
 * The API is language-neutral: every verdict arrives as a code, and the words live in
 * `locales/{ar,en}.js`. Nothing here translates anything.
 */

import { secureApi } from './secureApi';

const supervisorApi = {
  /**
   * Counts, the ranked attention list, and the clean-time figure.
   * `limit` trims the list only — the counts are always of everything.
   */
  getWorklist: (limit) =>
    secureApi.get('/api/v1/supervisor/worklist', { params: limit ? { limit } : {} }),

  /**
   * «تقارير الأداء» — per-cleaner figures for a period. `{ period: 'last7'|'thisMonth'|'lastMonth' }`
   * (resolved in Riyadh on the server) or `{ from, to }` as YYYY-MM-DD business dates.
   */
  getCleaningPerformance: (params) =>
    secureApi.get('/api/v1/supervisor/cleaning-performance', { params }),

  /** «تابعت» — record that somebody pushed whoever holds this task. Changes nothing about the task. */
  chaseTask: (taskId, note) =>
    secureApi.post(`/api/v1/supervisor/tasks/${taskId}/chase`, note ? { note } : {})
};

export default supervisorApi;
